export interface FormatPreset {
  id: string;
  label: string;
  category: string;
  width: number;
  height: number;
}

export const FORMAT_PRESETS: FormatPreset[] = [
  // Instagram
  { id: 'ig-post', label: 'Instagram Post', category: 'Instagram', width: 1080, height: 1080 },
  { id: 'ig-story', label: 'Instagram Story', category: 'Instagram', width: 1080, height: 1920 },
  { id: 'ig-landscape', label: 'Instagram Landscape', category: 'Instagram', width: 1080, height: 566 },

  // Facebook
  { id: 'fb-post', label: 'Facebook Post', category: 'Facebook', width: 1200, height: 630 },
  { id: 'fb-cover', label: 'Facebook Cover', category: 'Facebook', width: 820, height: 312 },
  { id: 'fb-story', label: 'Facebook Story', category: 'Facebook', width: 1080, height: 1920 },

  // TikTok
  { id: 'tiktok-video', label: 'TikTok Video', category: 'TikTok', width: 1080, height: 1920 },

  // X (Twitter)
  { id: 'x-post', label: 'X Post', category: 'X', width: 1200, height: 675 },
  { id: 'x-header', label: 'X Header', category: 'X', width: 1500, height: 500 },

  // Pinterest
  { id: 'pin-standard', label: 'Pinterest Pin', category: 'Pinterest', width: 1000, height: 1500 },

  // LinkedIn
  { id: 'li-post', label: 'LinkedIn Post', category: 'LinkedIn', width: 1200, height: 627 },

  // YouTube
  { id: 'yt-thumbnail', label: 'YouTube Thumbnail', category: 'YouTube', width: 1280, height: 720 },

  // Custom
  { id: 'custom-square', label: 'Square (1:1)', category: 'Custom', width: 1000, height: 1000 },
  { id: 'custom-a4', label: 'A4 Portrait', category: 'Custom', width: 2480, height: 3508 },
];

export function getPresetById(id: string): FormatPreset | undefined {
  return FORMAT_PRESETS.find((p) => p.id === id);
}

export function getPresetCategories(): string[] {
  const categories = new Set(FORMAT_PRESETS.map((p) => p.category));
  return Array.from(categories);
}
